import { render, staticRenderFns } from "./ActivityWsImageWithTextContainer.vue?vue&type=template&id=49a3f4d4&scoped=true"
import script from "./ActivityWsImageWithTextContainer.vue?vue&type=script&lang=ts"
export * from "./ActivityWsImageWithTextContainer.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsImageWithTextContainer.vue?vue&type=style&index=0&id=49a3f4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a3f4d4",
  null
  
)

/* custom blocks */
import block0 from "./ActivityWsImageWithTextContainer.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports